
<template>
    <footer id="footer" class="footer">
        <div class="copyright">
            &copy; Copyright <strong><span>Megacad</span></strong>. All Rights Reserved
        </div>
        <!-- <div class="credits">
            Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
        </div> -->
    </footer>
</template>
  
<script>
  export default {
    name: 'Footer',
  };
</script>
  
<style scoped>
  /* Estilos específicos del footer (si es necesario) */
</style>
  